<template>
  <div class="row mb-3">
    <div class="col-4">
      <div class="label">โครงการ</div>
      <project-select v-model="value.project"></project-select>
    </div>
    <div class="col-4">
      <div class="label">บ้าน</div>
      <el-select
        class="select"
        :value="homeValues"
        @input="handleChangeHomes"
        filterable
        clearable
        multiple
        placeholder="เลือกบ้าน"
        :filter-method="handleFilterHomes"
        valueKey="homeId"
        labelKey="addressNo"
      >
        <el-option
          v-for="home in projectHomeOptions"
          :key="home.homeId"
          :value="home.homeId"
          :label="home.addressNo || home.plotCode"
        ></el-option>
      </el-select>
    </div>
    <div class="col-4">
      <div class="label">ฐานะ</div>
      <el-select
        class="select"
        v-model="value.role"
        clearable
        placeholder="เลือกฐานะ"
      >
        <el-option
          v-for="role in roleOptions"
          :key="role.value"
          :value="role.value"
          :label="role.label"
        ></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import ProjectSelect from "@/lib/components/ProjectSelect";
import { baanRueJaiClient } from "@/dependencies";
import { userRoleMapper } from "@/lib/mapper";
import { isEmpty } from "ramda";

export default {
  components: {
    ScButton,
    ProjectSelect,
    "el-select": Select,
    "el-option": Option
  },
  props: ["value"],
  data() {
    const homeQuery = "";
    const projectHomes = [];
    const projectHomeByIds = {};
    const roleOptions = Object.keys(userRoleMapper).map(key => ({
      value: key,
      label: userRoleMapper[key]
    }));

    return {
      projectHomes,
      projectHomeByIds,
      homeQuery,
      roleOptions
    };
  },
  computed: {
    projectHomeOptions() {
      if (!this.homeQuery) {
        return this.projectHomes;
      }

      return this.projectHomes.filter(home => {
        if (isEmpty(home.addressNo)) {
          return home.plotCode.includes(this.homeQuery);
        }

        return home.addressNo.includes(this.homeQuery);
      });
    },
    homeValues() {
      return this.value.homes.map(({ homeId }) => homeId);
    }
  },
  watch: {
    ["value.project"](newVal, oldVal) {
      if (newVal === null) {
        this.resetForm();
        return;
      }

      if (oldVal !== null && newVal.projectId === oldVal.projectId) {
        return;
      }

      this.updateProjectHomes();
    }
  },
  methods: {
    async updateProjectHomes(projectId) {
      try{
        const result = await this.fetchProjectHomes(projectId);

        this.projectHomes = result;
        this.projectHomeByIds = result.reduce((all, home) => {
          all[home.homeId] = home;
          return all;
        }, {});
      } catch(error) {
        console.log(error);

        this.projectHomes = [];
        this.projectHomeByIds = [];
      }

      this.homeQuery = "";
      this.$emit("input", { ...this.value, homes: [], role: null });
    },
    async fetchProjectHomes() {
      const { projectId } = this.value.project;

      const response = await baanRueJaiClient.admin.memberManagement.projects.homes(
        projectId
      );

      return response.data;
    },
    async handleFilterHomes(query) {
      this.homeQuery = query;
    },
    handleChangeHomes(homeIds) {
      this.$emit("input", {
        ...this.value,
        homes: homeIds.map(id => this.projectHomeByIds[id])
      });
    },
    resetForm() {
      this.$emit("input", {
        ...this.value,
        homes: [],
        role: null,
        project: null
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.user-role {
  font-weight: bold;
}

.select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/features/managements/modules/users/components/AddHome.vue